export default __webpack_public_path__ + "static/mateusz_lopacki-76de4181c56f1715b91b0dab289ba31f.jpg";